import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DefaultService as KontoverbindungenService } from '@kontoverbindungen-api';
import { SuxExceptionBase, SuxExceptionService } from '@suva-ch/suvauxlib/modules/exception';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { KontoverbindungModel } from '../shared/model/kontoverbindung.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'kvb-kontoverbindungen',
  templateUrl: './kontoverbindungen.component.html',
  styleUrl: './kontoverbindungen.component.scss',
})
export class KontoverbindungenComponent extends SuxExceptionBase implements OnInit {
  private refresh$ = new BehaviorSubject(undefined);
  private readonly destroyRef = inject(DestroyRef);

  kontoverbindungen$: Observable<KontoverbindungModel[]>;
  kontoverbindungForEditing?: KontoverbindungModel;
  isInEditMode = false;

  constructor(
    private readonly kontoverbindungenService: KontoverbindungenService,
    private readonly suxExceptionService: SuxExceptionService
  ) {
    super();
  }
  ngOnInit(): void {
    this.kontoverbindungen$ = this.refresh$.pipe(
      switchMap(() =>
        this.kontoverbindungenService.findPersoenlichKontoverbindungen(true).pipe(
          takeUntilDestroyed(this.destroyRef),
          map(dto =>
            dto.kontoverbindungen.map(
              kontoverbindung => ({
                ...kontoverbindung,
                bic: '',
              }),
              catchError(() => {
                this.addException(this.suxExceptionService.createException());
                return of([] as KontoverbindungModel[]);
              })
            )
          )
        )
      )
    );
  }

  onEditClick(kontoverbindungEdit: KontoverbindungModel) {
    this.kontoverbindungForEditing = kontoverbindungEdit;
    this.isInEditMode = true;
  }

  onNewClick() {
    this.kontoverbindungForEditing = undefined;
    this.isInEditMode = true;
  }

  onKontoverbindungSaved() {
    this.isInEditMode = false;
    this.kontoverbindungForEditing = undefined;
    this.refresh$.next(undefined);
  }
}
